module.exports = __webpack_public_path__ + "static/6-Jar detail top-088c597b45ba427b9dcd172f67487792.jpg";